import {FC, useState} from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

type InterpreterNotesButtonProps = {
  interpreterId?: string
  onClick: () => void
  className?: string
}

const InterpreterNotesButton: FC<InterpreterNotesButtonProps> = ({
  interpreterId,
  onClick,
  className = 'btn btn-icon btn-primary btn-sm',
}) => {
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <OverlayTrigger
      placement='left'
      trigger={['hover']}
      show={showTooltip}
      onToggle={setShowTooltip}
      overlay={<Tooltip id={`notes-${interpreterId}`}>View Interpreter Notes</Tooltip>}
    >
      <button
        type='button'
        aria-label='View Interpreter Notes'
        className={className}
        onClick={() => {
          setShowTooltip(false)
          onClick()
        }}
      >
        <i className='bi bi-journal-text'></i>
      </button>
    </OverlayTrigger>
  )
}

export default InterpreterNotesButton
